import styled, { css } from "styled-components";

export const StyledLabelWrapper = styled.label`
    position: relative;
    width: 100%;
    height: 100%;
`;

export const StyledSlider = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 10px;
    box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.16);
    cursor: pointer;
    transition: .4s;
    :before {
        content: "";
        position: absolute;
        top: 2px;
        left: 3px;
        height: 16px;
        width: 16px;
        border-radius: 50%;
        background-color: ${({ theme }) => theme.colors.purple};
        opacity: 0.2;
        transition: .4s;
    };
`;

export const StyledInput = styled.input`
    visibility: hidden;
    opacity: 0;
    width: 0;
    height: 0;
    :checked +  ${StyledSlider} {
        :before {
            opacity: 1;
            transform: translateX(16px);
        };
    };
`;

export const StyledSwitchContainer = styled.div`
    display: inline-flex;
    align-items: center;
    height: 20px;
    width: 38px;
    ${({ disabled }) => disabled && css`
        pointer-events: none;
        opacity: 0.5;
  `};
  ${({ customStyle }) => customStyle && customStyle};
`;